import AbsensiPegawai from '../../../views/Personnel/Absensi/AbsensiPegawai.absensi.view';

export default AbsensiPegawai;